import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "user-body"
};
var _hoisted_2 = {
  class: "logo-body"
};
var _hoisted_3 = {
  class: "user-info"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "info-detail"
};
var _hoisted_6 = {
  class: "user-name ellipsis"
};
var _hoisted_7 = {
  style: {
    "margin-right": "4px"
  }
};
var _hoisted_8 = {
  class: "temperature"
};
var _hoisted_9 = {
  class: "weather-text ellipsis"
};
var _hoisted_10 = {
  class: "weather"
};
var _hoisted_11 = {
  class: "level-title"
};
var _hoisted_12 = {
  class: "margin-r8"
};
var _hoisted_13 = {
  class: "margin-r8"
};
var _hoisted_14 = {
  class: "rank-name"
};
var _hoisted_15 = {
  class: "level-title"
};
var _hoisted_16 = {
  class: "level-progress"
};
var _hoisted_17 = {
  class: "level-point"
};
import RoleSwitchDialog from './RoleSwitchDialog.vue';
import { getDefaultSchool, getCurrentWeather
// getCurrentSemesterBySchoolId,
// getLevelRankDetail,
// getUserTypeSchoolList,
} from '@/api/home';
import { getSignOut } from '@/api/user.js';
import { appAliasEvent } from '@/utils/auth.js';
import { DialogPlugin } from 'tdesign-vue-next';
import { validateNull } from '@/util/validate';
import { clearStore } from '@/util/store';
import { onMounted, reactive, ref, computed } from 'vue';
import { skipUrl as skipUrlOpen, toLogin } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useTaskApi } from '@/hooks/useTaskApi';
export default {
  __name: 'UserInfo',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      userInfo = _storeToRefs.userInfo,
      accountInfo = _storeToRefs.accountInfo,
      currentRole = _storeToRefs.currentRole,
      token = _storeToRefs.token;
    console.log(userInfo);
    var _useTaskApi = useTaskApi(),
      fetchUserTypeSchoolList = _useTaskApi.fetchUserTypeSchoolList,
      fetchCurrentSemesterBySchoolId = _useTaskApi.fetchCurrentSemesterBySchoolId,
      fetchLevelRankDetail = _useTaskApi.fetchLevelRankDetail;
    var avatar = require('@/assets/defaultAvatar1.png');
    var router = useRouter();

    /* 常量 */
    // 天气
    var weatherType = {
      CLEAR_DAY: {
        icon: 'clear-day',
        text: '晴天'
      },
      // 晴（白天）
      CLEAR_NIGHT: {
        icon: 'clear-night',
        text: '晴天'
      },
      // 晴（夜间）
      PARTLY_CLOUDY_DAY: {
        icon: 'partly-cloudy-day',
        text: '多云'
      },
      // 多云（白天）
      PARTLY_CLOUDY_NIGHT: {
        icon: 'partly-cloudy-night',
        text: '多云'
      },
      // 多云（夜间）
      CLOUDY: {
        icon: 'cloudy',
        text: '阴'
      },
      // 阴
      WIND: {
        icon: 'wind',
        text: '大风'
      },
      // 大风
      LIGHT_RAIN: {
        icon: 'light-rain',
        text: '小雨'
      },
      // 小雨
      MODERATE_RAIN: {
        icon: 'moderate-rain',
        text: '中雨'
      },
      // 中雨
      HEAVY_RAIN: {
        icon: 'heavy-rain',
        text: '大雨'
      },
      // 大雨
      STORM_RAIN: {
        icon: 'storm-rain',
        text: '暴雨'
      },
      // 暴雨
      LIGHT_SNOW: {
        icon: 'light-snow',
        text: '小雪'
      },
      // 小雪
      MODERATE_SNOW: {
        icon: 'moderate-snow',
        text: '中雪'
      },
      // 中雪
      HEAVY_SNOW: {
        icon: 'heavy-snow',
        text: '大雪'
      },
      // 大雪
      STORM_SNOW: {
        icon: 'storm-snow',
        text: '暴雪'
      },
      // 暴雪
      LIGHT_HAZE: {
        icon: 'haze',
        text: '轻度雾霾'
      },
      // 轻度雾霾
      MODERATE_HAZE: {
        icon: 'haze',
        text: '中度雾霾'
      },
      // 中度雾霾
      HEAVY_HAZE: {
        icon: 'haze',
        text: '重度雾霾'
      },
      // 重度雾霾
      FOG: {
        icon: 'fog',
        text: '雾'
      },
      // 雾
      SAND: {
        icon: 'fog',
        text: '沙尘'
      },
      // 沙尘
      DUST: {
        icon: 'fog',
        text: '浮尘'
      } //浮尘
    };

    /* 变量 */
    var stateInfo = reactive({
      headImg: '',
      // 头像
      userName: '',
      // 用户名
      institutionName: '',
      // 职位
      weatherText: '',
      // 天气
      weatherQuailty: '轻度污染',
      //空气质量
      weatherIcon: '',
      // 天气code
      temperature: null // 温度
    });
    var showRoleSwitch = ref(false);

    /**
     * 身份显示
     */
    var identity = computed(function () {
      if (validateNull(currentRole.value)) return '--';
      return {
        manager: '管理员',
        teacher: '教师',
        student: '学生'
      }[currentRole.value];
    });
    // 根据id获取用户信息
    var getIdUser = function getIdUser(userItem) {
      if (validateNull(userItem)) return;
      stateInfo.headImg = userItem.avatar || avatar;
      stateInfo.userName = userItem.name || userItem.nickname;
      stateInfo.institutionName = userItem.institutionName;
    };
    // 获取默认学校信息
    var getDefSchool = function getDefSchool() {
      return new Promise(function (resolve) {
        getDefaultSchool().then(function (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          } else {
            resolve(false);
          }
        }).catch(function (err) {
          resolve(false);
        });
      });
    };
    // 获取当前天气信息
    var getCurWeather = function getCurWeather(info) {
      var data = {
        address: info.provinceName + info.cityName + info.areaName,
        areaCode: info.areaCode.slice(0, 6),
        institutionId: info.id
      };
      getCurrentWeather(data).then(function (res) {
        if (res.data.code === 0) {
          var _data = res.data.data;
          stateInfo.weather = _data === null || _data === void 0 ? void 0 : _data.skyconName.split('（')[0];
          if (!validateNull(_data.skyconCode)) {
            var skyconCode = _data.skyconCode || 'CLEAR_DAY';
            var weatherObj = weatherType[skyconCode];
            stateInfo.weatherIcon = weatherObj.icon;
            stateInfo.weatherText = weatherObj.text;
          }
          stateInfo.temperature = _data.temperature;
        }
      });
    };
    onMounted(function () {
      initData();
    });

    /**
     * 初始化数据
     */
    // 等级段位等信息
    var schoolList = ref([]);
    var schoolId = ref('');
    var semesterInfo = ref({});
    var levelInfo = ref({});
    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _schoolList$value$, _semesterInfo$value, schoolInfo;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              userInfo.value && getIdUser(userInfo.value);
              if (!(accountInfo.value.accountType !== 2)) {
                _context.n = 6;
                break;
              }
              _context.n = 1;
              return getDefSchool();
            case 1:
              schoolInfo = _context.v;
              schoolInfo && getCurWeather(schoolInfo);
              // 获取学校列表
              _context.n = 2;
              return fetchUserTypeSchoolList(userInfo.value.id, currentRole.value === 'student' ? 2 : 1);
            case 2:
              schoolList.value = _context.v;
              schoolId.value = ((_schoolList$value$ = schoolList.value[0]) === null || _schoolList$value$ === void 0 ? void 0 : _schoolList$value$.schoolId) || '';
              if (!schoolId.value) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return fetchCurrentSemesterBySchoolId(schoolId.value);
            case 3:
              semesterInfo.value = _context.v;
            case 4:
              if (!((_semesterInfo$value = semesterInfo.value) !== null && _semesterInfo$value !== void 0 && _semesterInfo$value.id)) {
                _context.n = 6;
                break;
              }
              _context.n = 5;
              return fetchLevelRankDetail({
                userId: userInfo.value.id,
                semesterId: semesterInfo.value.id,
                currentSemesterFlag: 1
              });
            case 5:
              levelInfo.value = _context.v;
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    //退出
    var handleLogout = function handleLogout() {
      var DialogInstance = DialogPlugin.confirm({
        theme: 'warning',
        header: '是否确认退出？',
        confirmBtn: '是',
        cancelBtn: '否',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  getSignOut().then(function (res) {
                    if (res.data.code === 0) {
                      DialogInstance.destroy();
                      clearStore();
                      toLogin();
                    }
                  });
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    };
    //跳转个人中心
    var handleCenter = function handleCenter() {
      router.push('/accountInfo');
    };
    //跳转天气
    var goWeather = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var appUrl, url;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return appAliasEvent('weather');
            case 1:
              appUrl = _context3.v;
              url = "".concat(appUrl, "?token=").concat(token.value);
              skipUrlOpen(url);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function goWeather() {
        return _ref2.apply(this, arguments);
      };
    }();

    /**
     * 切换角色
     */
    var handleRoleSwitch = function handleRoleSwitch() {
      showRoleSwitch.value = true;
    };
    // 跳转积分任务中心
    var handleTask = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var appUrl, url;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return appAliasEvent(currentRole.value === 'student' ? 'pointsCenterStudent' : 'pointsCenterTeacher');
            case 1:
              appUrl = _context4.v;
              url = "".concat(appUrl, "?token=").concat(token.value);
              skipUrlOpen(url);
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleTask() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _levelInfo$value, _levelInfo$value2, _levelInfo$value3, _levelInfo$value4, _levelInfo$value5, _levelInfo$value6, _levelInfo$value7, _levelInfo$value8, _levelInfo$value9, _levelInfo$value0, _levelInfo$value1, _levelInfo$value10, _levelInfo$value11, _levelInfo$value12;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_progress = _resolveComponent("t-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "logo",
        size: "24"
      }), _createElementVNode("span", null, _toDisplayString(stateInfo.institutionName), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "avatar",
        src: stateInfo.headImg,
        alt: "",
        onClick: handleCenter
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(stateInfo.userName), 1), _createElementVNode("div", {
        class: "user-identity",
        onClick: handleRoleSwitch
      }, [_createElementVNode("span", _hoisted_7, _toDisplayString(identity.value), 1), _createVNode(_component_svg_icon, {
        name: "swap",
        size: "10"
      })])]), _createElementVNode("div", {
        class: "weather-info",
        onClick: goWeather
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(stateInfo.weatherQuailty), 1), _createVNode(_component_svg_icon, {
        name: stateInfo.weatherIcon
      }, null, 8, ["name"]), _createElementVNode("span", _hoisted_9, _toDisplayString(stateInfo.weatherText), 1), _createElementVNode("span", null, _toDisplayString(stateInfo.temperature) + " °C", 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_svg_icon, {
        name: "task-icon",
        class: "task-centre",
        onClick: _withModifiers(handleTask, ["stop"])
      }), _createElementVNode("div", {
        class: "logout",
        onClick: _withModifiers(handleLogout, ["stop"])
      }, [_createVNode(_component_svg_icon, {
        name: "logout"
      })])])])]), Object.keys(levelInfo.value).length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "level-info",
        onClick: _withModifiers(handleTask, ["stop"])
      }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, _toDisplayString(_unref(currentRole) === 'student' ? "LV".concat((_levelInfo$value = levelInfo.value) === null || _levelInfo$value === void 0 || (_levelInfo$value = _levelInfo$value.studentLevelInfo) === null || _levelInfo$value === void 0 ? void 0 : _levelInfo$value.currentLevelNum) : "LV".concat((_levelInfo$value2 = levelInfo.value) === null || _levelInfo$value2 === void 0 || (_levelInfo$value2 = _levelInfo$value2.teacherLevelInfo) === null || _levelInfo$value2 === void 0 ? void 0 : _levelInfo$value2.currentLevelNum)), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(currentRole) === 'student' ? (_levelInfo$value3 = levelInfo.value) === null || _levelInfo$value3 === void 0 || (_levelInfo$value3 = _levelInfo$value3.studentLevelInfo) === null || _levelInfo$value3 === void 0 ? void 0 : _levelInfo$value3.currentLevelName : (_levelInfo$value4 = levelInfo.value) === null || _levelInfo$value4 === void 0 || (_levelInfo$value4 = _levelInfo$value4.teacherLevelInfo) === null || _levelInfo$value4 === void 0 ? void 0 : _levelInfo$value4.currentLevelName), 1)]), _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(currentRole) === 'student' ? (_levelInfo$value5 = levelInfo.value) === null || _levelInfo$value5 === void 0 || (_levelInfo$value5 = _levelInfo$value5.studentRankInfo) === null || _levelInfo$value5 === void 0 ? void 0 : _levelInfo$value5.currentRankName : (_levelInfo$value6 = levelInfo.value) === null || _levelInfo$value6 === void 0 || (_levelInfo$value6 = _levelInfo$value6.teacherRankInfo) === null || _levelInfo$value6 === void 0 ? void 0 : _levelInfo$value6.currentRankName), 1)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_t_progress, {
        percentage: (_unref(currentRole) === 'student' ? (_levelInfo$value7 = levelInfo.value) === null || _levelInfo$value7 === void 0 || (_levelInfo$value7 = _levelInfo$value7.userPointInfo) === null || _levelInfo$value7 === void 0 ? void 0 : _levelInfo$value7.studentTotalPoint : (_levelInfo$value8 = levelInfo.value) === null || _levelInfo$value8 === void 0 || (_levelInfo$value8 = _levelInfo$value8.userPointInfo) === null || _levelInfo$value8 === void 0 ? void 0 : _levelInfo$value8.teacherTotalPoint) / (_unref(currentRole) === 'student' ? (_levelInfo$value9 = levelInfo.value) === null || _levelInfo$value9 === void 0 || (_levelInfo$value9 = _levelInfo$value9.studentLevelInfo) === null || _levelInfo$value9 === void 0 ? void 0 : _levelInfo$value9.nextLevelThreshold : (_levelInfo$value0 = levelInfo.value) === null || _levelInfo$value0 === void 0 || (_levelInfo$value0 = _levelInfo$value0.teacherLevelInfo) === null || _levelInfo$value0 === void 0 ? void 0 : _levelInfo$value0.nextLevelThreshold) * 100,
        trackColor: "#FCEFDF",
        color: "#FFA63A",
        label: false,
        size: "small"
      }, null, 8, ["percentage"])]), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(currentRole) === 'student' ? (_levelInfo$value1 = levelInfo.value) === null || _levelInfo$value1 === void 0 || (_levelInfo$value1 = _levelInfo$value1.userPointInfo) === null || _levelInfo$value1 === void 0 ? void 0 : _levelInfo$value1.studentTotalPoint : (_levelInfo$value10 = levelInfo.value) === null || _levelInfo$value10 === void 0 || (_levelInfo$value10 = _levelInfo$value10.userPointInfo) === null || _levelInfo$value10 === void 0 ? void 0 : _levelInfo$value10.teacherTotalPoint) + "/" + _toDisplayString(_unref(currentRole) === 'student' ? ((_levelInfo$value11 = levelInfo.value) === null || _levelInfo$value11 === void 0 || (_levelInfo$value11 = _levelInfo$value11.studentLevelInfo) === null || _levelInfo$value11 === void 0 ? void 0 : _levelInfo$value11.nextLevelThreshold) || '-' : ((_levelInfo$value12 = levelInfo.value) === null || _levelInfo$value12 === void 0 || (_levelInfo$value12 = _levelInfo$value12.teacherLevelInfo) === null || _levelInfo$value12 === void 0 ? void 0 : _levelInfo$value12.nextLevelThreshold) || '-'), 1)])])) : _createCommentVNode("", true), _createVNode(RoleSwitchDialog, {
        visible: showRoleSwitch.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return showRoleSwitch.value = $event;
        })
      }, null, 8, ["visible"])]);
    };
  }
};